import { render, staticRenderFns } from "./LSV.vue?vue&type=template&id=b5b6209a&scoped=true"
import script from "./LSV.vue?vue&type=script&lang=js"
export * from "./LSV.vue?vue&type=script&lang=js"
import style0 from "./LSV.vue?vue&type=style&index=0&id=b5b6209a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b6209a",
  null
  
)

export default component.exports